import { Injectable } from '@angular/core';
import { SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';
import { PublisherAccount } from 'app/modules/main/models/account';

@Injectable({ providedIn: 'root' })
export class PublisherSelectorMapper {

  public toPublisherAccount(
    selectablePublishers: SelectableData<PublisherAccount>[]
  ): PublisherAccount[] {

    return selectablePublishers
      .map(selectedPublisher => selectedPublisher.data);
  }

  public toSelectablePublishers(
    publishers: PublisherAccount[],
    selectedPublishers: PublisherAccount[]
  ): SelectableData<PublisherAccount>[] {

    const selectedPublisherIds =
      new Set(
        selectedPublishers
          .map(selectedPublisher => selectedPublisher.accountId)
      );

    return publishers
      .map(publisher => {
        return {
          data: publisher,
          id: String(publisher.accountId),
          label: publisher.name,
          selected: selectedPublisherIds.has(publisher.accountId),
        };
      });
  }

}
